import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import VibanaMark from './VibanaMark';

const SOCIAL_LINKS = [
  {
    href: 'https://instagram.com/vibana.app',
    label: 'Instagram',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.8"/>
        <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8"/>
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor"/>
      </svg>
    ),
  },
  {
    href: 'https://tiktok.com/@vibana.app',
    label: 'TikTok',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.19a8.16 8.16 0 004.77 1.52V6.27a4.85 4.85 0 01-1-.58z"/>
      </svg>
    ),
  },
  {
    href: 'https://twitter.com/vibana_app',
    label: 'X (Twitter)',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
  },
];

export default function Footer() {
  const { VB } = useTheme();
  return (
    <footer style={{ background: VB.void, borderTop: `1px solid ${VB.borderDark}` }}>
      {/* Animated gradient accent bar */}
      <div style={{ height:3, background:'linear-gradient(90deg, var(--red) 0%, var(--gold) 50%, var(--teal) 100%)', backgroundSize:'200% 100%', animation:'footer-gradient-shift 6s ease infinite' }} />
      <div style={{ padding:'64px 24px 40px' }}>
      <div style={{ maxWidth:1000, margin:'0 auto' }}>
        <div className="footer-grid" style={{ display:'grid', gridTemplateColumns:'1.8fr 1fr 1fr 1fr', gap:40, marginBottom:40 }}>

          {/* Brand */}
          <div>
            <div style={{ fontSize:30, fontWeight:500, color:'rgba(251,244,230,0.98)', marginBottom:14, fontFamily:'var(--font-display)', fontOpticalSizing:'auto', letterSpacing:'-0.02em', display:'flex', alignItems:'center' }}>
              <VibanaMark size={26} title="" style={{ marginRight: 8 }} />
              vibana
            </div>
            <p style={{ fontSize:13, color:'rgba(250,247,242,0.65)', lineHeight:1.75, marginBottom:16, maxWidth:260 }}>
              Discover African culture, music, food and community events across the US and Canada.
            </p>
            <div style={{ display:'flex', gap:7, marginBottom:18 }}>
              {['#E63946','#E9C061','#12B886'].map(c => (
                <div key={c} style={{ width:9, height:9, borderRadius:'50%', background:c }} />
              ))}
            </div>
            {/* Social icons */}
            <div style={{ display:'flex', gap:12 }}>
              {SOCIAL_LINKS.map(({ href, label, icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  style={{ color:'rgba(250,247,242,0.60)', display:'flex', alignItems:'center', transition:'color 0.15s' }}
                  onMouseEnter={e => e.currentTarget.style.color='rgba(250,247,242,0.95)'}
                  onMouseLeave={e => e.currentTarget.style.color='rgba(250,247,242,0.60)'}
                >
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* Discover */}
          <div>
            <div style={{ fontSize:10, fontWeight:700, color:'var(--gold)', letterSpacing:'0.22em', marginBottom:16, textTransform:'uppercase' }}>DISCOVER</div>
            {[['Events','/events'],['Community','/magazine'],['Get the app','/get-app'],['Submit event','/submit-event']].map(([l,t]) => (
              <Link key={l} to={t} style={{ display:'block', fontSize:13, color:'rgba(250,247,242,0.65)', textDecoration:'none', marginBottom:10, transition:'color 150ms' }}
                onMouseEnter={e => e.target.style.color='#E63946'}
                onMouseLeave={e => e.target.style.color='rgba(250,247,242,0.65)'}>
                {l}
              </Link>
            ))}
          </div>

          {/* Organizers */}
          <div>
            <div style={{ fontSize:10, fontWeight:700, color:'var(--gold)', letterSpacing:'0.22em', marginBottom:16, textTransform:'uppercase' }}>ORGANIZERS</div>
            {[['Post an event','/submit-event'],['Advertise with us','/advertise'],['Become an Organizer','/work-with-us/organizers']].map(([l,t]) => (
              <Link key={l} to={t} style={{ display:'block', fontSize:13, color:'rgba(250,247,242,0.65)', textDecoration:'none', marginBottom:10, transition:'color 150ms' }}
                onMouseEnter={e => e.target.style.color='#E63946'}
                onMouseLeave={e => e.target.style.color='rgba(250,247,242,0.65)'}>
                {l}
              </Link>
            ))}
          </div>

          {/* Company */}
          <div>
            <div style={{ fontSize:10, fontWeight:700, color:'var(--gold)', letterSpacing:'0.22em', marginBottom:16, textTransform:'uppercase' }}>COMPANY</div>
            {[['Help & Support','/help'],['Privacy Policy','/privacy'],['Terms of Service','/terms'],['Cookie Policy','/cookies'],['Acceptable Use','/acceptable-use'],['Accessibility','/accessibility'],['Contact Us','/contact']].map(([l,t]) => (
              <Link key={l} to={t} style={{ display:'block', fontSize:13, color:'rgba(250,247,242,0.65)', textDecoration:'none', marginBottom:10, transition:'color 150ms' }}
                onMouseEnter={e => e.target.style.color='#E63946'}
                onMouseLeave={e => e.target.style.color='rgba(250,247,242,0.65)'}>
                {l}
              </Link>
            ))}
          </div>
        </div>

        <div style={{ borderTop:'1px solid rgba(250,247,242,0.07)', paddingTop:20, display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:12 }}>
          <p style={{ fontSize:12, color:'rgba(250,247,242,0.65)', margin:0 }}>
            © 2026 Vibana
          </p>
          <div style={{ display:'flex', gap:20 }}>
            {[['Privacy','/privacy'],['Terms','/terms'],['Help','/help']].map(([l,t]) => (
              <Link key={l} to={t} style={{ fontSize:12, color:'rgba(250,247,242,0.60)', textDecoration:'none', transition:'color 150ms' }}
                onMouseEnter={e => e.currentTarget.style.color = '#E63946'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(250,247,242,0.60)'}>
                {l}
              </Link>
            ))}
          </div>
        </div>
      </div>
      </div>
    </footer>
  );
}
